import { IGroup } from '../auth/group.interface';
import { IBaseModel } from '../base/base-model.interface';
import { createEnumOptions } from '../shared/enum-option.interface';

export enum AccessType {
  collocation = 1,
  remoteZa = 2,
  remoteBa = 3,
}

export enum ConstraintType {
  ISP = 'isp',
  SP = 'sp',
}

export interface ILocation extends IBaseModel<'Location'> {
  region?: string;

  county?: string;

  city?: string;

  district?: string;

  oltNames?: string;

  submitted?: boolean;

  // accessType: AccessType;
}

export interface ILocationPenetration {
  county?: string;

  city?: string;

  districts: string[];

  oltNames: string[];

  total: number;

  connectable: number;

  taken: number;

  penetration: number;
}

export interface ILocationPenetrationDetail {
  county: string;

  city: string;

  locationId: string;

  district: string;

  /**
   * Total count of locations in this district
   */
  total: number;

  /**
   * Total count of connectable locations in this district
   */
  totalConnectable: number;

  /**
   * Total count of access points with construction status complete or readyForSale
   */
  totalCompleted: number;

  /**
   * Taken count of locations in this district
   */
  taken: number;

  /**
   * Penetration of locations in this district
   */
  penetration: number;

  /**
   * Counts of taken locations in this district grouped by group
   */
  takenDetails: ILocationPenetrationTakenDetail[];

  /**
   * Service partners associated with this location
   */
  servicePartners: ILocationPenetrationServicePartner[];
}

export interface ILocationPenetrationServicePartner {
  oltName: string;
  groupId: string | null;
  group?: IGroup | null;
}

export interface ILocationPenetrationTakenDetail {
  /**
   * Group for this count
   */
  group?: IGroup | null;

  /**
   * Id of the group for this count
   */
  groupId: string | null;

  /**
   * Count of taken for this group (or free locations if group is null)
   */
  count: number;

  /**
   * Optional flag indicating if the location is submitted
   */
  submitted?: boolean;

  /**
   * Optional override label for display (e.g. 'Obsadené' for other ISPs' taken, 'Voľné' for free)
   */
  label?: string;
}

export const accessTypeOptions = createEnumOptions<AccessType>({
  [AccessType.collocation]: { label: 'Kolokácia' },
  [AccessType.remoteZa]: { label: 'Remote ZA' },
  [AccessType.remoteBa]: { label: 'Remote BA' },
  _default: { label: '-' },
});
